// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3W8nr","name":"Header_name__3GRyN","birthday":"Header_birthday__2mPJf","skeleton":"Header_skeleton__1UxpD"};